import "./ItemSales.css";
import { Checkbox, Tags } from "../../../ui";
import AppFileNode from "../../components/AppFileNode/AppFileNode";
import ReportFilesManager from "../../components/ReportFilesManager/ReportFilesManager";
import { fileNameOf, isVersionedReport } from "../../components/ReportFileSlot/ReportFileSlot";
import { APPS, MONTH_NAMES } from "../../utils/ludDocuments.constants";
import { formatDate, getLudFileName, openLudFile } from "../../utils/ludDocuments.helpers";

export default function ItemSales({
  restaurant,
  lang,
  token,
  refreshRestaurant,
  canManage,
  onError,
}) {
  const ar = lang === "ar";
  
  // if (!restaurant.hasItemSales) {
  //   return (
  //     <NoticeBox variant="info">
  //       {ar
  //         ? "مبيعات الأصناف غير مفعّلة لهذا المطعم — لا توجد ملفات متوقعة ولا تنبيهات لهذا القسم."
  //         : "Item sales are not enabled for this restaurant; no files or alerts are expected in this section."}
  //     </NoticeBox>
  //   );
  // }

  const currentMonthName = MONTH_NAMES[lang][new Date().getMonth()];
  const periods = ar
    ? [`الفترة الأولى — ${currentMonthName} (١ – ٩)`, `الفترة الثانية — ${currentMonthName} (١٠ – ٢٤)`]
    : [`First period — ${currentMonthName} (1–9)`, `Second period — ${currentMonthName} (10–24)`];
  const periodOptions = [
    { value: "period1", label: ar ? "الفترة الأولى" : "First period" },
    { value: "period2", label: ar ? "الفترة الثانية" : "Second period" },
  ];

  return (
    <ReportFilesManager
      canManage={canManage}
      onError={onError}
      restaurant={restaurant}
      lang={lang}
      token={token}
      refreshRestaurant={refreshRestaurant}
      reportType="itemSales"
      title={ar ? "رفع مبيعات الأصناف" : "Upload item sales"}
      periodOptions={periodOptions}
      renderReports={({ reportsByApp, renderFileSlot, deleteMode, selectedIds, toggleSelected }) => (
        <>
          {restaurant.enabledApps.map((key) => {
            const missing = restaurant.itemSalesMissing.includes(key);
            const appReports = (reportsByApp[key] || []).slice().sort((a, b) =>
              Number(b.year) - Number(a.year) || Number(b.month) - Number(a.month));

            return (
              <AppFileNode
                key={key}
                title={APPS[key].label[lang]}
                subtitle={appReports.length > 0
                  ? `${MONTH_NAMES[lang][Number(appReports[0].month) - 1]} ${appReports[0].year}`
                  : ar ? "لا توجد ملفات بعد" : "No files yet"}
                status={missing ? (ar ? "فترة ناقصة" : "Missing period") : ar ? "مكتمل" : "Complete"}
                statusVariant={missing ? "danger" : "success"}
              >
                {appReports.length > 0 ? Object.entries(
                  appReports.reduce((groups, report) => {
                    const groupKey = `${report.year}-${report.month}`;
                    groups[groupKey] = [...(groups[groupKey] || []), report];
                    return groups;
                  }, {}),
                ).map(([groupKey, groupReports]) => {
                  const [year, month] = groupKey.split("-").map(Number);
                  return (
                    <div key={groupKey}>
                      <div className="lud-report-tree-title">{year} — {ar ? "السنة" : "Year"}</div>
                      <div className="lud-report-tree-title">{MONTH_NAMES[lang][month - 1]} {year} — {ar ? "الشهر" : "Month"}</div>
                      {groupReports.map((report) => {
                        const periodLabel = periodOptions.find((option) => option.value === report.period)?.label || report.period;
                        const thisMissing = missing && report.period === "period2";

                        return (
                          <div className="lud-report-file lud-report-file--actual" key={report.id}>
                            {deleteMode && (
                              <Checkbox
                                checked={selectedIds.includes(report.id)}
                                onChange={() => toggleSelected(report.id)}
                                onClick={(event) => event.stopPropagation()}
                              />
                            )}
                            <div className="lud-report-file__content">
                              <strong>{periodLabel}</strong>
                              <button
                                type="button"
                                className="lud-file-name-link"
                                onClick={() => openLudFile(report.currentFile, { token, storeId: restaurant.id, kind: "report", reference: report.id, onError })}
                              >
                                {isVersionedReport(report) ? fileNameOf(report) : report.currentFile ? getLudFileName({ file: { ...report.currentFile, app: key, type: "itemSales" }, kind: "report", reference: report.id, originalName: report.currentFile.originalName }) : (ar ? "اكسل مبيعات الأصناف" : "Item sales Excel")}
                              </button>
                              {renderFileSlot(report)}
                            </div>
                            <div className="lud-report-file__meta">
                              <span>
                                {report.currentFile?.uploadedAt
                                  ? `${ar ? "رُفع بتاريخ" : "Uploaded on"} ${formatDate(report.currentFile.uploadedAt, lang)}`
                                  : thisMissing ? "—" : ar ? "مرفوع" : "Uploaded"}
                              </span>
                              <Tags variant={thisMissing ? "danger" : "success"}>
                                {thisMissing ? (ar ? "غير مرفوعة" : "Not uploaded") : ar ? "سارٍ" : "Valid"}
                              </Tags>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                }) : periods.map((period) => {
                  return (
                    <div className="lud-report-file" key={period}>
                      <div>
                        <strong>{period}</strong>
                        <small>{ar ? "اكسل مبيعات الأصناف" : "Item sales Excel"}</small>
                      </div>
                      <div className="lud-report-file__meta">
                        <span>—</span>
                        <Tags variant={missing ? "danger" : "neutral"}>
                          {ar ? "غير مرفوعة" : "Not uploaded"}
                        </Tags>
                      </div>
                    </div>
                  );
                })}
              </AppFileNode>
            );
          })}
        </>
      )}
    />
  );
}
